import { render } from "./GalleryC.vue?vue&type=template&id=694a93c2"
import script from "./GalleryC.vue?vue&type=script&lang=js"
export * from "./GalleryC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__